import React, { Fragment } from 'react';

interface PrettyTextListProps {
  items: string[];
  separator?: string;
  lastSeparator?: string;
  format?: (item: string, index: number) => React.ReactNode;
}

function PrettyTextList(props: PrettyTextListProps) {
  const { items } = props;

  if (!items.length) {
    return null;
  }

  return (
    <>
      {items.map((item: string, index: number) => {
        const text = props.format ? props.format(item, index) : item;
        const isFirst = index === 0;
        const isLast = index === props.items.length - 1;
        let separator: string | null = props.separator || ', ';

        if (isFirst) {
          separator = null;
        } else if (isLast && props.lastSeparator) {
          separator = props.lastSeparator;
        }

        return (
          <Fragment key={index}>
            {separator}
            {text}
          </Fragment>
        );
      })}
    </>
  );
}

export default PrettyTextList;
